
const Footer = ({ menuCollapsed }) => {
  return (
    <div className="copyrights_footerpanel">
      <div className="copyrights_footerpanel_left" style={{ paddingLeft: menuCollapsed ? '10px' : '10px' }}>© {new Date().getFullYear()} COPYRIGHT LISCR LLC, ALL RIGHTS RESERVED<span style={{ padding: "0px 12px" }}>|</span><span className="copyrights_footerpanel_middle"><a className="footer_email_link_privacy" href="https://www.liscr.com/contact-us/privacy-policy" target="_blank" style={{ color: "#838383" }}>Privacy Policy</a>
      </span></div>
      <div className="copyrights_footerpanel_right" style={{ paddingLeft: menuCollapsed ? '10px' : '10px' }}>Contact us : <a className="footer_email_link" href="mailto:wpcloudsupport@liscr.com">WPCloudSupport@liscr.com</a></div>
    </div>
  )
}

export default Footer